export const acceptableAttributes = [
  'Primary Color',
  'Gender',
  'Brand Name',
  'Decoration Technology 1',
  'Size',
  'Material',
  'Type',
  'Quality',
  'Sleeves',
  'Ink Color',
  'Collar',
  'Collar Type',
  'Side Pockets',
  'Computer Size',
  'Backpack Strap Type',
  'USB Capacity',
  'Shoulder Strap Features',
  'Strap Number Shoulder Strap',
  'Closure',
  'Backpack Strap Features',
  'Handle Number - Carry Handle',
  'Special Sizes',
  'Number of Sheets',
  'Co-ordinating styles',
  'Main Compartment Closure',
  'Shelf Life',
  'Handle Material',
  'Sleeve Features',
  'Can Capacity',
  'Computer Compartment Features',
  'Pocket Closure Side Pocket',
  'Closure Type',
  'Number of pieces per pack',
  'Pieces Featured',
  'Handle Features Carry Handle',
  'Closure Feature Main Compartment',
  'Number of USB Ports',
  'Scent',
  'Device Compatibility',
  'Battery Size',
  'Features',
  'Pockets',
  'Fit',
  'Special Features',
  'Volume',
  'Paper Weight',
  'Paper Size',
  'Business Card Holder',
  'Collar Fastner',
  'Device Type',
  'Binding Type',
  'Paper Type',
  'Functions',
  'Pocket',
  'Fastener Type',
  'Cuff Type',
  'Hood',
  'Alarm Clock Functions',
  'Brim',
  'Crown',
  'Panels',
  'Eyelets',
  'Specific size-Cap',
  'Net quantity and Pack size',
  'Sleeve Style',
  'Chocolate Type',
  'Candy - subcategory',
  'User information',
  'Allergens',
  'Producer',
  'Foil Type',
  'EcoFriendly',
  'Outside Pocket(s)',
  'Inside Pocket(s)',
  'Has Leakproof cap',
  'Colour Change',
  'Substrate Color',
  'Backside'
];

export const mappingRowTypes = {
  ATTRIBUTE: 0,
  ATTRIBUTE_VALUE: 1,
  NEW_ATTRIBUTE_VALUE_MAPPING: 2
};

export const mappingRowTypeIds = ['Attribute', 'AttributeValue', 'NewAttributeValue'];
export const mappingRowTypeLabels = ['Attribute', 'Attribute Value', 'New Attribute Value'];
